import { useQuery } from '@tanstack/react-query'
import { supabase } from '../lib/supabase'

export interface ArmourMaterial {
  material_id: string
  prot_blunt: number
  prot_edge: number
  prot_point: number
  prot_fire: number
}

export function useRefArmourMaterials() {
  return useQuery({
    queryKey: ['ref_armour_materials'],
    queryFn: async () => {
      const { data, error } = await supabase.from('ref_armour_materials').select('material_id, prot_blunt, prot_edge, prot_point, prot_fire')
      if (error) throw error
      return data as ArmourMaterial[]
    },
    staleTime: Infinity,
  })
}
